export const namespace = 'ui-search-search-modal';
export const filterNamespace = 'ui-search-filter';

export const MODAL_TYPES = {
  WITH_SEARCH: 'WITH_SEARCH',
  DEFAULT: 'DEFAULT',
};
